import mainStyle from "./mainStyle.module.scss";
import React, { useState, useEffect } from "react";
import { cloneDeep } from "lodash";
import { v4 as uuidv4 } from "uuid";
// Service
import useDataSourceManager from "hooks/useDataSourceManager";
import { useAuth } from "contexts/AuthContext";
import { useUserContext } from "contexts/UserContext";
import { TextField, Grid, Box, Typography } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, animateScroll as scroll } from "react-scroll";
import btn_account from "assets/images/icons/btn_account.svg";
import btn_account_light from "assets/images/icons/btn_account_light.svg";
import btn_mfa from "assets/images/icons/btn_mfa.svg";
import btn_mfa_light from "assets/images/icons/btn_mfa_light.svg";

import { ReactComponent as VerifiedIcon } from "assets/images/icons/icn_table_cell_Verified.svg";
import { ReactComponent as AddIcon } from "assets/images/icons/btn_add.svg";
import { ReactComponent as FavorSubIcon } from "assets/images/icons/icn_favorite_unselected.svg";
import { ReactComponent as FavorIcon } from "assets/images/icons/icn_favorite_selected.svg";

import ModalContainer from "components/ModalContainer";
import ModalforCheck from "./modalComponents/modalCheck.js";
import ModalforPhoto from "./modalComponents/modalPhoto";
import ModalforPassword from "./modalComponents/modalPassword";
import ModalforAuth from "./modalComponents/modalAuth";
import ModalConfirmPw from "./modalComponents/modalConfirmPw";

import { OutlineWarnButton } from "components/buttons/OutlineWarnButton";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";
import { ReactComponent as UploadIcon } from "assets/images/icons/icn_btn_export_pressed.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin.svg";
import { MenuSelect } from "./components/menuSelect";
import { getServerURL, getAppApiURL } from "../../utils/serverUrl";
import { postLogoutWithFormBody } from "../../utils/logout";

const AUTO_LOGOUT_CHANNEL = "apim-portal-auto-logout";
const checkMockup = process.env.REACT_APP_IS_MOCKUP;
const checkContext = process.env.REACT_APP_RUNNING_CONTEXT;
const orgID = process.env.REACT_APP_ORGANIZATIONNAME;
const serverURL = getServerURL();
const serverApiURL = getAppApiURL();

const userDefault = {
  uId: "id-001",
  name: "butter",
  displayName: "butter",
  email: "butter@mail.com",
  avatar: "",
  logoutLimit: "",
  language: "",
  password: "zxcv1234",
};

const authObjDefault = {
  authName: "",
  mfaType: "",
  enabled: true,
  isPreferred: "",
};

const langDefault = [
  { id: "en", text: "English" },
  { id: "tc", text: "Traditional Chinese" },
];

const logoutEmpty = {
  id: "",
  text: "",
};

const logoutDefault = [
  { id: "900", text: "15 min" },
  { id: "1800", text: "30 min" },
  { id: "3600", text: "60 min" },
];

const Profile = () => {
  const { token } = useAuth();
  const { setUserContext } = useUserContext();
  const [userToken, setUserToken] = useState(null);
  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager();
  // email, avatar, name, language, owner, password?

  const isJuxtaposed = useMediaQuery(theme.breakpoints.up("lg"));

  const [openModalCheck, setOpenModalCheck] = useState(false);
  const [openModalPhoto, setOpenModalPhoto] = useState(false);
  const [openModalPassword, setOpenModalPassword] = useState(false);
  const [openModalAuth, setOpenModalAuth] = useState(false);
  const [openModalConfirmPw, setOpenModalConfirmPw] = useState(false);

  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [modalSaveBtn, setModaSaveBtn] = useState("");
  const [modalCancelBtn, setModalCancelBtn] = useState("");
  const [modalSaveAlert, setModaSaveAlert] = useState(false);

  const [nowAnchor, setNowAnchor] = useState("section1");

  // for modalCheck & confirmPw to check which function
  const [modalFrom, setModalFrom] = useState("");
  const [modalAction, setModalAction] = useState(false);

  // for modalAuth to check which function
  const [modalType, setModalType] = useState("");
  const [modalStep, setModalStep] = useState("p1");

  const [originUser, setOriginUser] = useState(null);

  const [langList, setLangList] = useState(cloneDeep(langDefault));
  const [logoutList, setLogoutList] = useState(cloneDeep(logoutDefault));

  const [userPhoto, setUserPhoto] = useState("");
  const [uName, setUName] = useState("");
  const [userNameInput, setUserNameInput] = useState("");
  const [userNameInputErr, setUserNameInputErr] = useState(false);
  const [userMailInput, setUserMailInput] = useState("");
  const [userMailInputErr, setUserMailInputErr] = useState(false);
  const [userLang, setUserLang] = useState(cloneDeep(langDefault[0]));
  const [userLogout, setUserLogout] = useState(cloneDeep(logoutEmpty));

  const [authApp, setAuthApp] = useState(null);
  const [authEmail, setAuthEmail] = useState(null);
  const [delAuthBtn, setDelAuthBtn] = useState(null);
  const [deleteUuid, _setDeleteUuid] = useState(uuidv4());

  const handleAnchor = (section) => {
    setNowAnchor(section);
  };
  const handleDelAcc = () => {
    setModalFrom("DeletePW");
    setModalTitle("Delete account");
    setModalContent("Enter your account password to delete account.");
    setModaSaveBtn("Delete");
    setModalCancelBtn("Cancel");
    setOpenModalConfirmPw(true);
  };

  const handleAddMFA = (type, step) => {
    if (type === "email" && originUser.email === "") {
      setModalFrom("Notice");
      setModalTitle("Missing Email Address");
      setModalContent(
        "To proceed with email authentication, please enter your email address.",
      );
      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);
      return;
    }
    setModalTitle("Protect your account with Multi-Factor Authentication");
    setModalContent("");
    setModaSaveBtn("Next");
    setModalCancelBtn("Back");
    setModalType(type);
    setModalStep(step);
    setOpenModalAuth(true);
  };

  const handlePassword = () => {
    setModalTitle("Change Password");
    setModalContent("");
    setModaSaveBtn("Change Password");
    setModalCancelBtn("Cancel");
    setOpenModalPassword(true);
  };

  const handleUploadPhoto = () => {
    setModalTitle("Upload Image");
    setModalContent("");
    setModaSaveBtn("Upload");
    setModalCancelBtn("Cancel");
    setOpenModalPhoto(true);
  };

  const handleRemovePhoto = () => {
    setModalFrom("DeletePhoto");
    setModalTitle("Remove Image");
    setModalContent("Are you sure you want to delete the image?");
    setModaSaveBtn("Remove");
    setModaSaveAlert(true);
    setModalCancelBtn("No");
    setOpenModalCheck(true);
  };

  const handleSaveUser = () => {
    let updateUser = cloneDeep(originUser);
    updateUser.avatar = userPhoto;
    updateUser.email = userMailInput;
    updateUser.displayName = userNameInput;
    // updateUser.name = userNameInput

    updateUser.properties = {
      ...(updateUser.properties || {}),
      auto_logout_time_limit: userLogout?.id || "",
    };
    updateUser.language = userLang.id;

    if (
      userNameInput === "" ||
      userNameInput === null ||
      userNameInput === undefined
    ) {
      setUserNameInputErr(true);
      return;
    }

    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let checkMailFormat = emailRegex.test(userMailInput);
    if (
      userMailInput === "" ||
      userMailInput === null ||
      userMailInput === undefined
    ) {
      if (checkContext === "cloud") {
        setUserMailInputErr(true);
        return;
      } else {
        updateUser.email = "";
      }
    } else {
      if (checkMailFormat !== true) {
        setUserMailInputErr(true);
        return;
      }
    }

    setOriginUser(updateUser);
    if (checkMockup === "true") {
      setModalFrom("Finish");
      setModalTitle("Success");
      setModalContent("Your setting has been saved.");
      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);
    } else {
      saveUserData(updateUser);
    }
  };

  const handleCancelUser = () => {
    setModalFrom("RevertUser");
    setModalTitle("Revert");
    setModalContent(
      "Are you sure you want to discard the current changes and restore the previous settings?",
    );
    setModaSaveBtn("Revert");
    setModaSaveAlert(false);
    setModalCancelBtn("Cancel");
    setOpenModalCheck(true);
  };

  const handleName = (e) => {
    setUserNameInputErr(false);
    let tmpVal = e.target.value;
    setUserNameInput(tmpVal);
  };
  const handleMail = (e) => {
    setUserMailInputErr(false);
    let tmpVal = e.target.value;
    setUserMailInput(tmpVal);
  };

  const handleLogout = (opt) => {
    let tmpLangId = opt.label;
    let result = logoutList.filter((item) => item.id.toString() === tmpLangId);
    setUserLogout(result[0]);
  };

  const handleLanguage = (opt) => {
    let tmpLangId = opt.label;
    let result = langList.filter((item) => item.id.toString() === tmpLangId);
    setUserLang(result[0]);
  };

  const handleDeleteMFA = () => {
    //delete mfa
    setModalFrom("DeleteMFA");
    setModalTitle("Remove MFA settings");
    setModalContent("Enter your account password to remove all settings.");
    setModaSaveBtn("Remove");
    setModalCancelBtn("Cancel");
    setOpenModalConfirmPw(true);
  };

  const handlePreferMFA = (authObj) => {
    preferSetupMFA(authObj);
  };

  const loadingPage = (tName) => {
    getUserData(tName);
  };

  const logoutAndRedirect = async () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    const token = localStorage.getItem("token");
    try {
      await postLogoutWithFormBody({
        serverURL,
        token,
        redirectUri: `${serverApiURL}/login`,
      });
    } catch (error) {
      console.error("Logout redirect failed:", error);
    }

    localStorage.clear();
    sessionStorage.clear();
  };

  useEffect(() => {
    if (checkMockup === "true") {
      setOriginUser(cloneDeep(userDefault));

      setUName(userDefault.name);
      setUserNameInput(userDefault.displayName);
      setUserMailInput(userDefault.email);
      setUserPhoto(userDefault.avatar);
      setUserLang(cloneDeep(langDefault[0]));
      setUserLogout(cloneDeep(logoutEmpty));
    } else {
      let tokenSetting = jwtDecode(token);
      setUserToken(tokenSetting);
      loadingPage(tokenSetting.name);
    }
  }, []);

  useEffect(() => {
    if (openModalCheck === false && modalAction === true) {
      if (modalFrom === "DeletePhoto") {
        setModalAction(false);
        setUserPhoto(null);
      } else if (modalFrom === "RevertUser") {
        setModalAction(false);
        let initUser = cloneDeep(originUser);
        setUserNameInput(initUser.displayName);
        setUserMailInput(initUser.email);
        setUserPhoto(initUser.avatar);

        if (initUser.properties?.auto_logout_time_limit) {
          const result = logoutList.find(
            (item) =>
              item.id.toString() ===
              initUser.properties.auto_logout_time_limit.toString(),
          );

          setUserLogout(result || cloneDeep(logoutEmpty));
        } else {
          setUserLogout(cloneDeep(logoutEmpty));
        }

        if (initUser.language === "" || initUser.language === null) {
          setUserLang(cloneDeep(langDefault[0]));
        } else {
          let result = langList.filter(
            (item) => item.id.toString() === initUser.language,
          );
          if (result.length > 0) {
            setUserLang(result[0]);
          } else {
            setUserLang(cloneDeep(langDefault[0]));
          }
        }
      } else if (modalFrom === "Finish") {
        window.location.reload();
      } else if (modalFrom === "DeleteAccountFinish") {
        setModalAction(false);
        logoutAndRedirect();
      } else {
        setModalAction(false);
      }
    }
  }, [openModalCheck]);

  useEffect(() => {
    if (openModalConfirmPw === false && modalAction === true) {
      if (modalFrom === "DeleteMFA") {
        setModalAction(false);
        deleteSetupMFA();
      } else if (modalFrom === "DeletePW") {
        setModalAction(false);
        /* let updateUser = cloneDeep(originUser) */
        deleteUserData();
      }
    }
  }, [openModalConfirmPw]);

  const deleteUserData = () => {
    sendRequest("/me.delete", deleteUuid);
  };

  useEffect(() => {
    const response = getData(deleteUuid);

    if (response?.message) {
      setModalFrom("DeleteAccountFinish");
      setModalTitle("Success");
      setModalContent("Your account has been removed.");
      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);
    }

    if (response?.code) {
      const msg = response?.message;
      setModalFrom("DeleteAccountError");
      setModalTitle("Action denied");
      setModalContent(msg);
      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);
    }
  }, [dataMap]);

  const deleteSetupMFA = async () => {
    // const updateData = new URLSearchParams();
    // updateData.append("owner", orgID);
    // updateData.append("name", userToken.name);
    let updateData = {
      owner: orgID,
      name: userToken.name,
    };

    // const response = await UserService.deleteMfaSetting(updateData, token)
    const response = await sendRequest(
      "casdoor/UserService/.deleteMfaSetting",
      null,
      null,
      updateData,
    );

    if (response.status === "ok") {
      setModalFrom("Finish");
      setModalTitle("Success");
      setModalContent("Your MFA setting has been deleted.");
      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);

      getUserData(userToken.name);
      // need refresh setOriginUser multiFactorAuths
    } else {
      // error msg
    }
  };

  const preferSetupMFA = async (authObj) => {
    // const updateData = new URLSearchParams();
    // updateData.append("mfaType", authObj.mfaType);
    // updateData.append("owner", orgID);
    // updateData.append("name", userToken.name);
    let updateData = {
      mfaType: authObj.mfaType,
      owner: orgID,
      name: userToken.name,
    };

    // const response = await UserService.preferMfaSetting(updateData, token)
    const response = await sendRequest(
      "casdoor/UserService/.preferMfaSetting",
      null,
      null,
      updateData,
    );

    if (response.status === "ok") {
      if (authObj.isPreferred === true) {
        return;
      } else {
        let tmpAuth = cloneDeep(authObj);
        tmpAuth.isPreferred = true;
        if (tmpAuth.mfaType === "app") {
          setAuthApp(tmpAuth);
          let anotherAuth = cloneDeep(authEmail);
          anotherAuth.isPreferred = false;
          setAuthEmail(anotherAuth);
        } else {
          setAuthEmail(tmpAuth);
          let anotherAuth = cloneDeep(authApp);
          anotherAuth.isPreferred = false;
          setAuthApp(anotherAuth);
        }
      }
    } else {
      // error msg
    }
  };

  const getUserData = async (tName) => {
    const response = await sendRequest(
      "casdoor/UserService/.getUserSetting",
      null,
      null,
      { orgId: orgID, userName: tName },
    );
    // const response = await UserService.getUserSetting(orgID, tName)
    let initUser = response.data;
    setOriginUser(initUser);

    setUName(initUser.name);

    if (
      initUser.displayName === "" ||
      initUser.displayName === null ||
      initUser.displayName === undefined
    ) {
      setUserNameInput(initUser.name);
    } else {
      setUserNameInput(initUser.displayName);
    }
    setUserMailInput(initUser.email);
    setUserPhoto(initUser.avatar);

    if (initUser.properties?.auto_logout_time_limit) {
      const result = logoutList.find(
        (item) =>
          item.id.toString() ===
          initUser.properties.auto_logout_time_limit.toString(),
      );

      setUserLogout(result || cloneDeep(logoutEmpty));
    } else {
      setUserLogout(cloneDeep(logoutEmpty));
    }

    if (initUser.language === "" || initUser.language === null) {
      setUserLang(cloneDeep(langDefault[0]));
    } else {
      let result = langList.filter(
        (item) => item.id.toString() === initUser.language,
      );
      if (result.length > 0) {
        setUserLang(result[0]);
      } else {
        setUserLang(cloneDeep(langDefault[0]));
      }
    }

    if (initUser.multiFactorAuths[1].enabled !== false) {
      let authObj = cloneDeep(initUser.multiFactorAuths[1]);
      authObj.authName = "Email Authentication";
      setAuthEmail(authObj);
      setDelAuthBtn(true);
    } else {
      setAuthEmail(null);
    }

    if (initUser.multiFactorAuths[2].enabled !== false) {
      let authObj = cloneDeep(initUser.multiFactorAuths[2]);
      authObj.authName = "App Authentication";
      setAuthApp(authObj);
      setDelAuthBtn(true);
    } else {
      setAuthApp(null);
    }
  };

  // const [data, setData] = useState(null);
  // const [error, setError] = useState(null);
  const saveUserData = async (updateUser) => {
    // const response = await UserService.updateUserSetting(orgID, userToken.name, updateUser, token)
    const response = await sendRequest(
      "casdoor/UserService/.updateUserSetting",
      null,
      null,
      { orgId: orgID, userName: userToken.name, param: updateUser },
    );

    if (response.status === "ok") {
      // Header in this tab observes the updated context through its normal
      // user-setting flow. Notify any other open portal tabs as well.
      setUserContext(updateUser);

      if (typeof BroadcastChannel !== "undefined") {
        const channel = new BroadcastChannel(AUTO_LOGOUT_CHANNEL);
        channel.postMessage({
          type: "auto-logout-time-limit-updated",
          userId: updateUser.id,
          autoLogoutTime: updateUser.properties?.auto_logout_time_limit || null,
        });
        channel.close();
      }

      setModalFrom("Finish");
      setModalTitle("Success");
      setModalContent("Your setting has been saved.");
      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);
    } else {
      // error msg
      setModalFrom("Finish");
      setModalTitle("Action denied");

      const errMsg = response.msg;
      if (errMsg.includes("||||")) {
        let replacedMsg = formatString(errMsg);
        setModalContent(replacedMsg);
      } else {
        setModalContent(response.msg);
      }

      setModaSaveBtn("OK");
      setModaSaveAlert(false);
      setModalCancelBtn(null);
      setOpenModalCheck(true);
    }
  };

  const formatString = (errMsg) => {
    const [target, replaceStr] = errMsg.split("||||");
    if (!target) return "";

    const values = replaceStr ? replaceStr.split(",").map((v) => v.trim()) : [];

    let result = target;
    let i = 0;
    result = result.replace(/%s/g, () => values[i++] ?? "");

    return result;
  };

  // 顯示名稱縮寫
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  return (
    <>
      <div style={{ marginTop: "60px" }}>
        <div className={mainStyle["bread"]}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[2],
              fontWeight: theme.typography.customFontWeight[1],
              fontFamily: theme.typography.fontFamily,
            }}
          >
            Account Management
          </Typography>
        </div>
        <div className={mainStyle["mainArea"]}>
          <Grid
            container
            style={{ justifyContent: "space-between", marginBottom: "10px" }}
          >
            <div className={mainStyle["anchorArea"]}>
              <div className={mainStyle["anchorBody"]}>
                <Box style={{ marginLeft: "5px" }}>
                  <Link
                    to="section1"
                    smooth={true}
                    duration={500}
                    onClick={() => {
                      handleAnchor("section1");
                    }}
                  >
                    <div
                      className={mainStyle["anchorItem"]}
                      style={{
                        backgroundColor:
                          nowAnchor === "section1"
                            ? theme.palette.primary.main
                            : "",
                      }}
                    >
                      <img
                        alt="profile_section1"
                        src={
                          nowAnchor === "section1"
                            ? btn_account_light
                            : btn_account
                        }
                        style={{ width: "40px" }}
                      />
                      <span
                        className={mainStyle["anchorItem_text"]}
                        style={{
                          color:
                            nowAnchor === "section1"
                              ? theme.palette.primary.white
                              : theme.palette.primary.main,
                        }}
                      >
                        Account Profile
                      </span>
                    </div>
                  </Link>
                </Box>
                <Box style={{ marginLeft: "5px" }}>
                  <Link
                    to="section2"
                    smooth={true}
                    duration={500}
                    onClick={() => {
                      handleAnchor("section2");
                    }}
                  >
                    <div
                      className={mainStyle["anchorItem"]}
                      style={{
                        backgroundColor:
                          nowAnchor === "section2" ? "#172664" : "",
                      }}
                    >
                      <img
                        alt="profile_section2"
                        src={nowAnchor === "section2" ? btn_mfa_light : btn_mfa}
                        style={{ width: "40px" }}
                      />
                      <span
                        className={mainStyle["anchorItem_text"]}
                        style={{
                          color:
                            nowAnchor === "section2" ? "#ffffff" : "#172664",
                        }}
                      >
                        MFA Setting
                      </span>
                    </div>
                  </Link>
                </Box>
              </div>
              <div className={mainStyle["anchorTail"]}>
                <Box style={{ marginBottom: "10px" }}>
                  <OutlineWarnButton
                    // width="100px"
                    height="32px"
                    onClick={handleDelAcc}
                  >
                    Delete Account
                  </OutlineWarnButton>
                </Box>
              </div>
            </div>
            <div className={mainStyle["userArea"]}>
              <Grid style={{ marginBottom: "20px" }}>
                <Box id="section1">
                  <div className={mainStyle["userTitle"]}>
                    <Typography
                      variant="h4"
                      sx={{
                        mb: 2,
                        ml: 1,
                        mt: 2,
                        color: theme.palette.primary.main,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: theme.typography.customFontSize[5],
                        fontWeight: theme.typography.customFontWeight[3],
                      }}
                    >
                      Account Profile
                    </Typography>
                  </div>
                  <div className={mainStyle["userContent"]}>
                    <Box style={{ margin: "15px 0" }}>
                      <Grid container>
                        {userPhoto ? (
                          <img
                            src={userPhoto}
                            alt="profile_photo"
                            className={mainStyle["avatar_withPhoto"]}
                          />
                        ) : (
                          <div className={mainStyle["avatar_withoutPhoto"]}>
                            {originUser && getInitials(originUser.displayName)}
                          </div>
                        )}
                        <div className={mainStyle["avatarSetting"]}>
                          <Typography
                            sx={{
                              marginLeft: "30px",
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[2],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            You may upload an image of up to 2MB in size.
                          </Typography>
                          <Grid container>
                            <Box style={{ margin: "10px 0 0 30px" }}>
                              <OutlineRectangleButton
                                startIcon={<UploadIcon />}
                                // width="100px"
                                height="32px"
                                onClick={handleUploadPhoto}
                              >
                                Upload Image
                              </OutlineRectangleButton>
                            </Box>
                            <Box style={{ margin: "10px 0 0 30px" }}>
                              <OutlineRectangleButton
                                startIcon={<RemoveIcon />}
                                // width="100px"
                                height="32px"
                                onClick={handleRemovePhoto}
                              >
                                Remove Image
                              </OutlineRectangleButton>
                            </Box>
                          </Grid>
                        </div>
                      </Grid>
                    </Box>
                    <Grid container>
                      <Grid item md={12} lg={6}></Grid>

                      <Grid item md={12} lg={6}></Grid>
                    </Grid>
                    <Grid container>
                      <Grid
                        item
                        container
                        className={`${mainStyle["userOptionsLeft"]}`}
                        md={12}
                        lg={6}
                      >
                        {checkContext === "cloud" ? (
                          <></>
                        ) : (
                          <Grid
                            container
                            className={`${mainStyle["userOptions"]}`}
                          >
                            <Typography
                              sx={{
                                width: "80px",
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight:
                                  theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                            >
                              User Name
                            </Typography>
                            <Typography
                              sx={{
                                flexGrow: "1",
                                marginLeft: "15px",
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight:
                                  theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                            >
                              {uName}
                            </Typography>
                          </Grid>
                        )}
                        <Grid
                          container
                          className={`${mainStyle["userOptions"]}`}
                        >
                          <Typography
                            sx={{
                              width: "80px",
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Name
                          </Typography>
                          <TextField
                            value={userNameInput}
                            size="small"
                            onChange={(e) => handleName(e)}
                            variant="outlined"
                            error={userNameInputErr}
                            inputProps={{ style: { fontSize: "13px" } }}
                            sx={{
                              mr: 1,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px", // 改變圓角
                                "& fieldset": {
                                  borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                                },
                                "&:hover fieldset": {
                                  borderColor: theme.palette.primary.mainHover,
                                },
                                "&.Mui-focused fieldset": {
                                  border: "1px solid",
                                  borderColor: theme.palette.primary.main,
                                },
                              },
                            }}
                            style={{
                              flexGrow: "1",
                              maxWidth: "calc(100% - 85px)",
                              paddingLeft: "10px",
                            }}
                          />
                        </Grid>
                        <Grid
                          container
                          className={`${mainStyle["userOptions"]}`}
                        >
                          <Typography
                            sx={{
                              width: "80px",
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Email
                          </Typography>
                          {checkContext == "cloud" ? (
                            <Typography
                              sx={{
                                flexGrow: "1",
                                marginLeft: "15px",
                                color: theme.palette.primary.greyPrimary,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight:
                                  theme.typography.customFontWeight[1],
                                fontFamily: theme.typography.fontFamily,
                              }}
                            >
                              {userMailInput}
                            </Typography>
                          ) : (
                            <TextField
                              value={userMailInput}
                              size="small"
                              onChange={(e) => handleMail(e)}
                              variant="outlined"
                              error={userMailInputErr}
                              inputProps={{ style: { fontSize: "13px" } }}
                              sx={{
                                mr: 1,
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px", // 改變圓角
                                  "& fieldset": {
                                    borderColor:
                                      theme.palette.primary.greyThread, // 預設狀態的框線顏色
                                  },
                                  "&:hover fieldset": {
                                    borderColor:
                                      theme.palette.primary.mainHover,
                                  },
                                  "&.Mui-focused fieldset": {
                                    border: "1px solid",
                                    borderColor: theme.palette.primary.main,
                                  },
                                },
                              }}
                              style={{
                                flexGrow: "1",
                                maxWidth: "calc(100% - 85px)",
                                paddingLeft: "10px",
                              }}
                            />
                          )}
                        </Grid>
                        <Grid
                          container
                          className={`${mainStyle["userOptions"]}`}
                        >
                          <Typography
                            sx={{
                              width: "80px",
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Password
                          </Typography>
                          <Typography
                            sx={{
                              flexGrow: "1",
                              marginLeft: "15px",
                              cursor: "pointer",
                              color: theme.palette.primary.main,
                              textDecoration: "underline",
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                            onClick={handlePassword}
                          >
                            Change Password
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        container
                        className={`${mainStyle["userOptionsRight"]}`}
                        md={12}
                        lg={6}
                      >
                        <Grid
                          container
                          className={`${mainStyle["userOptions"]}`}
                        >
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Automatic logout time limit
                          </Typography>
                          <MenuSelect
                            value={userLogout?.text || ""}
                            onChange={(opt) => {
                              handleLogout(opt);
                            }}
                            options={(() => {
                              return logoutList.map((item, index) => ({
                                label: item.id,
                                key: index,
                                value: item.text,
                              }));
                            })()}
                            width={"calc(100% - 220px)"}
                            menuWidth={
                              isJuxtaposed
                                ? "calc(50% - 450px)"
                                : "calc(100% - 670px)"
                            }
                          />
                        </Grid>
                        {/* 2025/11/28 隱藏 */}
                        {/* <Grid container className={`${mainStyle['userOptions']}`}>
                          <Typography
                            sx={{
                              color: theme.palette.primary.greyPrimary,
                              fontSize: theme.typography.customFontSize[1],
                              fontWeight: theme.typography.customFontWeight[1],
                              fontFamily: theme.typography.fontFamily,
                            }}
                          >
                            Language
                          </Typography>
                          <MenuSelect
                            value={userLang.text}
                            onChange={(opt) => {handleLanguage(opt)}}
                            options={(() => {
                              return langList
                                .map((item, index) => ({
                                  label: item.id,
                                  key: index,
                                  value: item.text,
                                }));
                            })()}
                            width={'calc(100% - 220px)'}
                            menuWidth={isJuxtaposed?'calc(50% - 450px)':'calc(100% - 670px)'}
                          />
                        </Grid> */}
                      </Grid>
                    </Grid>
                    <Box>
                      <Grid
                        container
                        style={{ justifyContent: "center", width: "100%" }}
                      >
                        <Box style={{ margin: "10px" }}>
                          <OutlineButton
                            width="135px"
                            height="42px"
                            onClick={handleCancelUser}
                          >
                            Cancel
                          </OutlineButton>
                        </Box>
                        <Box style={{ margin: "10px" }}>
                          <SolidButton
                            width="135px"
                            height="42px"
                            onClick={handleSaveUser}
                          >
                            Save
                          </SolidButton>
                        </Box>
                      </Grid>
                    </Box>
                  </div>
                </Box>
                <Box id="section2">
                  <div className={mainStyle["userTitle"]}>
                    <Typography
                      variant="h4"
                      sx={{
                        mb: 2,
                        ml: 1,
                        mt: 2,
                        color: theme.palette.primary.main,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: theme.typography.customFontSize[5],
                        fontWeight: theme.typography.customFontWeight[3],
                      }}
                    >
                      MFA Setting
                    </Typography>
                    {delAuthBtn && (
                      <Box style={{ margin: "10px 0 0 30px" }}>
                        <OutlineRectangleButton
                          startIcon={<RemoveIcon />}
                          // width="100px"
                          height="32px"
                          onClick={handleDeleteMFA}
                        >
                          Remove MFA settings
                        </OutlineRectangleButton>
                      </Box>
                    )}
                  </div>
                  <div className={mainStyle["userContent"]}>
                    <Box>
                      <Grid
                        container
                        style={{ alignItems: "center", marginBottom: "10px" }}
                      >
                        {authApp ? (
                          <VerifiedIcon width={24} />
                        ) : (
                          <div style={{ width: "20px" }}></div>
                        )}
                        <div
                          style={{
                            width: "250px",
                            justifyContent: "space-between",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {authApp ? (
                            <>
                              <Typography
                                variant="h4"
                                sx={{
                                  ml: 1.5,
                                  color: theme.palette.primary.greyPrimary,
                                  fontFamily: theme.typography.fontFamily,
                                  fontSize: theme.typography.customFontSize[1],
                                  fontWeight:
                                    theme.typography.customFontWeight[1],
                                }}
                              >
                                {authApp.authName}
                              </Typography>
                              <Typography
                                variant="h4"
                                sx={{
                                  ml: 1.5,
                                  color: authApp.isPreferred
                                    ? theme.palette.primary.main
                                    : theme.palette.primary.mainHover,
                                  backgroundColor: authApp.isPreferred
                                    ? theme.palette.primary.subBlue
                                    : "",
                                  fontFamily: theme.typography.fontFamily,
                                  fontSize: theme.typography.customFontSize[0],
                                  fontWeight:
                                    theme.typography.customFontWeight[0],
                                  padding: "5px",
                                  borderRadius:
                                    theme.shape.customBorderRadius[0],
                                }}
                              >
                                {authApp.isPreferred
                                  ? "Primary"
                                  : "Set Primary"}
                              </Typography>
                            </>
                          ) : (
                            <Typography
                              variant="h4"
                              sx={{
                                ml: 2,
                                color: theme.palette.primary.greyThird,
                                fontFamily: theme.typography.fontFamily,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight:
                                  theme.typography.customFontWeight[1],
                              }}
                            >
                              App Authentication
                            </Typography>
                          )}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid rgba(0, 0, 0, 0.2)",
                            height: "24px",
                            marginLeft: authApp ? "20px" : "24px",
                            marginRight: authApp ? "12px" : "10px",
                          }}
                        ></div>
                        {authApp ? (
                          authApp.isPreferred ? (
                            <FavorIcon
                              width={22}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlePreferMFA(authApp);
                              }}
                            />
                          ) : (
                            <FavorSubIcon
                              width={22}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlePreferMFA(authApp);
                              }}
                            />
                          )
                        ) : (
                          <AddIcon
                            width={22}
                            style={{ cursor: "pointer", marginLeft: "2px" }}
                            onClick={() => {
                              handleAddMFA("app", "p1");
                            }}
                          />
                        )}
                      </Grid>
                      <Grid container style={{ alignItems: "center" }}>
                        {authEmail ? (
                          <VerifiedIcon width={24} />
                        ) : (
                          <div style={{ width: "20px" }}></div>
                        )}
                        <div
                          style={{
                            width: "250px",
                            justifyContent: "space-between",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {authEmail ? (
                            <>
                              <Typography
                                variant="h4"
                                sx={{
                                  ml: 1.5,
                                  color: theme.palette.primary.greyPrimary,
                                  fontFamily: theme.typography.fontFamily,
                                  fontSize: theme.typography.customFontSize[1],
                                  fontWeight:
                                    theme.typography.customFontWeight[1],
                                }}
                              >
                                {authEmail.authName}
                              </Typography>
                              <Typography
                                variant="h4"
                                sx={{
                                  ml: 1.5,
                                  color: authEmail.isPreferred
                                    ? theme.palette.primary.main
                                    : theme.palette.primary.mainHover,
                                  backgroundColor: authEmail.isPreferred
                                    ? theme.palette.primary.subBlue
                                    : "",
                                  fontFamily: theme.typography.fontFamily,
                                  fontSize: theme.typography.customFontSize[0],
                                  fontWeight:
                                    theme.typography.customFontWeight[0],
                                  padding: "5px",
                                  borderRadius:
                                    theme.shape.customBorderRadius[0],
                                }}
                              >
                                {authEmail.isPreferred
                                  ? "Primary"
                                  : "Set Primary"}
                              </Typography>
                            </>
                          ) : (
                            <Typography
                              variant="h4"
                              sx={{
                                ml: 2,
                                color: theme.palette.primary.greyThird,
                                fontFamily: theme.typography.fontFamily,
                                fontSize: theme.typography.customFontSize[1],
                                fontWeight:
                                  theme.typography.customFontWeight[1],
                              }}
                            >
                              Email Authentication
                            </Typography>
                          )}
                        </div>
                        <div
                          style={{
                            borderLeft: "1px solid rgba(0, 0, 0, 0.2)",
                            height: "24px",
                            marginLeft: authEmail ? "20px" : "24px",
                            marginRight: authEmail ? "12px" : "10px",
                          }}
                        ></div>
                        {authEmail ? (
                          authEmail.isPreferred ? (
                            <FavorIcon
                              width={22}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlePreferMFA(authEmail);
                              }}
                            />
                          ) : (
                            <FavorSubIcon
                              width={22}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlePreferMFA(authEmail);
                              }}
                            />
                          )
                        ) : (
                          <AddIcon
                            width={22}
                            style={{ cursor: "pointer", marginLeft: "2px" }}
                            onClick={() => {
                              handleAddMFA("email", "p1");
                            }}
                          />
                        )}
                      </Grid>
                    </Box>
                  </div>
                </Box>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <ModalContainer
        display={openModalCheck}
        modalWidth={"500px"} //550px, 750px, empty=1000px,
        children={
          <ModalforCheck
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            saveAlert={modalSaveAlert}
            setOpenModal={setOpenModalCheck}
            setModalAction={setModalAction}
          />
        }
      />
      <ModalContainer
        display={openModalPhoto}
        modalWidth={"550px"} //550px, 750px, empty=1000px,
        children={
          <ModalforPhoto
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalPhoto}
            setUserPhoto={setUserPhoto}
          />
        }
      />
      <ModalContainer
        display={openModalPassword}
        modalWidth={"600px"} //550px, 750px, empty=1000px,
        children={
          <ModalforPassword
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalPassword}
          />
        }
      />
      <ModalContainer
        display={openModalAuth}
        modalWidth={"600px"} //550px, 750px, empty=1000px,
        children={
          <ModalforAuth
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalAuth}
            modalType={modalType}
            modalStep={modalStep}
            originUser={originUser}
            loadingPage={loadingPage}
          />
        }
      />
      <ModalContainer
        display={openModalConfirmPw}
        modalWidth={"500px"} //550px, 750px, empty=1000px,
        children={
          <ModalConfirmPw
            title={modalTitle}
            content={modalContent}
            cancelBtn={modalCancelBtn}
            saveBtn={modalSaveBtn}
            setOpenModal={setOpenModalConfirmPw}
            originUser={originUser}
            setModalAction={setModalAction}
          />
        }
      />
    </>
  );
};

export default Profile;
